import { useState } from 'react';
import { Link } from 'react-router-dom';
import NewsNavbar from '@/components/feature/NewsNavbar';
import NewsFooter from '@/components/feature/NewsFooter';

export default function NewsSubscribePage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      await fetch('https://readdy.ai/api/form/d7ala3n6e3lk97049vd0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0E27] font-sans">
      <NewsNavbar />

      <main className="pt-28 md:pt-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-2xl mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm text-white/40 mb-6">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">Ana Sayfa</Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-white">Bülten Aboneliği</span>
            </nav>

            {submitted ? (
              <div className="bg-white/5 border border-white/10 rounded-2xl p-10 text-center">
                <div className="w-20 h-20 flex items-center justify-center bg-[#00FF88]/10 rounded-full mx-auto mb-6">
                  <i className="ri-check-line text-[#00FF88] text-4xl" />
                </div>
                <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
                  Aboneliğiniz Tamamlandı!
                </h1>
                <p className="text-white/50 text-base mb-8">
                  Teknonova bültenine başarıyla abone oldunuz. En güncel teknoloji haberlerini her sabah e-posta kutunuzda alacaksınız.
                </p>
                <Link
                  to="/"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-[#00D9FF] text-[#0A0E27] font-bold rounded-full hover:bg-[#00D9FF]/90 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-arrow-left-line" />
                  Ana Sayfaya Dön
                </Link>
              </div>
            ) : (
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10">
                <div className="text-center mb-8">
                  <i className="ri-mail-send-line text-5xl text-[#00D9FF] mb-4" />
                  <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
                    Günlük Teknoloji Bülteni
                  </h1>
                  <p className="text-white/50 text-base">
                    Teknoloji dünyasından en güncel haberler, analizler ve özel içerikler için bültenimize abone olun.
                  </p>
                </div>

                <form data-readdy-form id="newsletter-form" onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <label className="text-white/60 text-sm mb-2 block">Ad Soyad</label>
                    <input
                      type="text"
                      name="fullName"
                      required
                      placeholder="Adınız Soyadınız"
                      className="w-full bg-white/5 border border-white/10 text-white placeholder-white/20 text-sm px-4 py-3 rounded-xl outline-none focus:border-[#00D9FF]/50 transition-colors"
                    />
                  </div>

                  <div>
                    <label className="text-white/60 text-sm mb-2 block">E-posta Adresi</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="ornek@email.com"
                      className="w-full bg-white/5 border border-white/10 text-white placeholder-white/20 text-sm px-4 py-3 rounded-xl outline-none focus:border-[#00D9FF]/50 transition-colors"
                    />
                  </div>

                  <div>
                    <label className="text-white/60 text-sm mb-3 block">İlgi Alanları (İsteğe Bağlı)</label>
                    <div className="flex flex-wrap gap-2">
                      {['Yapay Zeka', 'Mobil', 'Oyun', 'Donanım', 'Yazılım', 'Girişimcilik'].map((tag) => (
                        <label key={tag} className="flex items-center gap-2 px-3 py-2 bg-white/5 border border-white/10 rounded-lg cursor-pointer hover:bg-white/10 transition-colors">
                          <input type="checkbox" name="interests" value={tag} className="accent-[#00D9FF]" />
                          <span className="text-white/70 text-sm">{tag}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="flex items-start gap-3 pt-2">
                    <input type="checkbox" id="consent" required className="mt-1 accent-[#00D9FF]" />
                    <label htmlFor="consent" className="text-white/50 text-sm">
                      Bülten aboneliği için kişisel verilerimin işlenmesine izin veriyorum. <a href="#" className="text-[#00D9FF] hover:underline">Gizlilik Politikası</a>'nı okudum ve kabul ediyorum.
                    </label>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full py-4 bg-[#00D9FF] text-[#0A0E27] font-bold rounded-xl hover:bg-[#00D9FF]/90 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-60"
                  >
                    {loading ? 'İşleniyor...' : 'Ücretsiz Abone Ol'}
                  </button>
                </form>

                <p className="text-white/30 text-xs text-center mt-6">
                  İstediğiniz zaman abonelikten çıkabilirsiniz.
                </p>
              </div>
            )}
          </div>
        </div>
      </main>

      <NewsFooter />
    </div>
  );
}
